import { combineReducers } from "redux";
import { authReducer } from "./auth/reducer";
import { menuReducer } from "./menu/reducer";
import { changeDeviceReducer } from "./changDevice/reducer"

export default combineReducers({
  auth: authReducer,
  menu: menuReducer,
  change: changeDeviceReducer
});
